"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("./types");
function queueDisconnectSource(sourceId) {
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var disconnectSource = arguments.length > 2 ? arguments[2] : undefined;
  return function (dispatch, getState) {
    var _getState = getState(),
      broadcastSourceDisconnectTimeouts = _getState.broadcastSourceDisconnectTimeouts;
    if (broadcastSourceDisconnectTimeouts[sourceId]) {
      //TODO: remove this...leaving for now for debugging
      console.log('Disconnect timeout already exists, doing nothing...');
      return;
    }
    var timeoutId = setTimeout(function () {
      dispatch(disconnectSource(sourceId));
    }, timeout);
    var action = {
      type: _types.BROADCAST_QUEUE_SOURCE_DISCONNECT,
      payload: {
        sourceId: sourceId,
        timeoutId: timeoutId
      }
    };
    dispatch(action);
  };
}
var _default = exports["default"] = queueDisconnectSource;